import theme from '../../../lib/theme';
import { HeroProps } from './Hero';

const {
  layouts,
  corners,
  scale,
  colors,
  media,
  font: {
    families,
    heights,

    ...font
  },
} = theme;

export default ({
  imageURL,
  brand,
  ctaColumns,
  overlayColor = colors[brand || 'sas'].primary,
}: HeroProps) => ({
  container: {
    ...layouts.column,

    display: 'flex',

    backgroundColor: overlayColor,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundImage: `linear-gradient(317.84deg, rgba(158,66,255,0.3) 0%, ${overlayColor} 100%), url('${imageURL}')`,
    borderRadius: corners.m,
    padding: scale.s,

    [media.s.up]: {
      padding: scale.m,
    },
  },

  title: {
    textShadow: imageURL ? '0 2px 10px rgba(0, 0, 0, 0.3)' : 'none',
  },

  terms: {
    [media.s.down]: {
      fontSize: `${font.xs} !important`,
      lineHeight: `${heights.xs} !important`,
    },

    '& a': {
      color: `${colors.white} !important`,
    },
  },

  description: {
    fontWeight: `${font.normal} !important`,
  },

  logo: {
    height: 'auto',
  },

  ctas: {
    ...layouts.column,

    alignItems: 'stretch',

    [media.s.up]: {
      ...layouts.row,

      alignItems: 'flex-start',
      flexWrap: 'wrap',
    },
  },

  cta: {
    marginTop: scale.s,
    flex: ctaColumns ? `100% 0` : 'none',

    [media.s.up]: {
      flex: ctaColumns ? `calc(50% - ${scale.s} / 2) 0` : 'none',
      marginRight: scale.s,
    },

    [media.l.up]: {
      flex: ctaColumns ? `calc(33.33% - ${scale.s} * 2 / 3) 0` : 'none',
    },

    '&:nth-child(3n)': ctaColumns
      ? {
          [media.l.up]: {
            marginRight: 0,
          },
        }
      : undefined,

    '&:nth-child(2n)': ctaColumns
      ? {
          [media.s.up]: {
            marginRight: 0,
          },

          [media.l.up]: {
            marginRight: scale.s,
          },
        }
      : undefined,

    '&:nth-child(6n)': ctaColumns
      ? {
          [media.l.up]: {
            marginRight: 0,
          },
        }
      : undefined,
  },

  innerTop: {
    ...layouts.spacedColumn('xxs'),

    width: '100%',
    maxWidth: 700,
  },

  heading: {
    ...layouts.spacedColumn('s'),
  },

  innerChildren: {
    ...layouts.spacedColumn('xs'),
  },
});
